import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { convertFromIdToName } from '../../../utils/helpers';
import useOutsideClick from '../../../hooks/useOutSideClick';
import M4ChartCustomLabelItem from './M4ChartCustomLabelItem';

import styles from '../sass/M4.module.scss';
import Arrow from '../../../assets/icons/ArrowRightChart.svg';

const M4ChartCustomLabelY = ({ driverYId, driversList, onChange }) => {
  const [openList, setOpenList] = useState(false);
  const handleChangeOpenList = useCallback(() => {
    setOpenList((prev) => !prev);
  }, []);

  const ref = useOutsideClick(handleChangeOpenList, !openList);

  return (
    <foreignObject style={{ overflow: 'visible' }} x={30} y={20} width={20} height={400}>
      <div ref={ref} className={styles.customLabelYContainer}>
        <div role="presentation" onClick={handleChangeOpenList} className={styles.labelContainer}>
          <img src={Arrow} alt="" />
          <div className={styles.driver}>
            {`Decision - Driver: ${driverYId ? convertFromIdToName(driversList, driverYId) : ''}`}
          </div>
        </div>

        <div className={`${styles.driversList} ${openList && styles.openDriversList}`}>
          <div className={styles.driversContainer}>
            {driversList.map(({ id, name }) => (
              <M4ChartCustomLabelItem
                key={id}
                name={name}
                active={driverYId === id}
                onClick={() => {
                  onChange(id);
                  handleChangeOpenList();
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </foreignObject>
  );
};

M4ChartCustomLabelY.propTypes = {
  driverYId: PropTypes.number.isRequired,
  driversList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  })),
  onChange: PropTypes.func.isRequired
};

M4ChartCustomLabelY.defaultProps = {
  driversList: []
};

export default M4ChartCustomLabelY;
